import envConfig from '@hulu/env-config';
import type { AxiosRequestConfig } from 'axios';
import { User } from 'mission-control-common-components';

import { sendTokenToWorker } from '../../configs/serviceWorkerInit';
import { getCognitoDetailsCached } from '../../utils/cognitoDetails';

export const authorizationInterceptors = async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
  if (envConfig.REACT_APP_AUTH_FEATURE_ENABLED !== 'true') return config;

  await User.checkIdToken(undefined, await getCognitoDetailsCached())
    .then(() => {
      sendTokenToWorker(navigator);
    })
    .catch((error) => {
      console.error(error);
    });

  const { idToken } = User.getUserInfo();

  // axios 0.34 types the method-specific header groups as AxiosHeaders, which a plain spread cannot satisfy
  const headers = { ...config.headers, authorization: `Bearer ${idToken}` } as AxiosRequestConfig['headers'];

  return { ...config, headers };
};
